<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol sm="3" md="3" xl="2" xs="12">
        <BaseInput :options="codeInput.options" :data="codeInput.data" :listener="codeInput.listener" />
      </CCol>
      <CCol sm="3" md="3" xl="2" xs="12">
        <BaseInput :options="nameInput.options" :data="nameInput.data" :listener="nameInput.listener" />
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton style="float: right;margin-left: 5px;" color="primary" v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary" @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp;Tải lại
            </CButton>
            <CButton style="float: right;;margin-left: 5px;" color="primary" v-c-tooltip.hover="'Thêm mới'" class="btn-action-primary"
              @click="clickAdd()">
              <i class="fa fa-plus"></i>&nbsp;Thêm mới
            </CButton>
            <CButton style="float: right;" color="success" v-c-tooltip.hover="'Import'" class="btn-action-primary"
              @click="setupImport()">
              <i class="fa fa-download"></i>&nbsp;Import
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable :options="mainTable.options" :slots="mainTable.slots" :dataSource="mainTable.dataSource"
          ref="mainTable">
          <template #index="{ index }">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>
          
          <template #name="{ item }">
            <td>
              <span style="font-weight: 550;">{{ item.name }}</span>
            </td>
          </template>

          <template #action="{ item }">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton color="info" variant="outline" v-c-tooltip.hover="'Cập nhật'" square size="sm"
                  @click="loadById(item.id)">
                  <CIcon name="cil-pencil" />
                </CButton>
                <CButton color="danger" variant="outline" class="ml-1" square size="sm" v-c-tooltip.hover="'Xóa'"
                  @click="setupSelectOneAction('delete_one', item.id, item.name)">
                  <CIcon name="cil-trash" />
                </CButton>
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>

    <CModal :title="dataSave.idField.data.model ? 'Cập nhật địa bàn' : 'Thêm mới địa bàn'" :show.sync="isShowModal"
      :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol sm="12" md="12" xl="12" xs="12">
          <BaseInput :options="dataSave.codeInput.options" :data="dataSave.codeInput.data"
            :listener="dataSave.codeInput.listener" />
          <BaseInput :options="dataSave.nameInput.options" :data="dataSave.nameInput.data"
            :listener="dataSave.nameInput.listener" />
            <BaseInput :options="dataSave.sourceIdInput.options" :data="dataSave.sourceIdInput.data"
            :listener="dataSave.sourceIdInput.listener" />
          <BaseSelect :options="dataSave.levelInput.options" :data="dataSave.levelInput.data" ref="levelInput">
          </BaseSelect>
          <BaseSelect v-if="dataSave.levelInput.data.model != 0" :options="dataSave.parentSelect.options" :data="dataSave.parentSelect.data"
            ref="parentSelect"></BaseSelect>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="isShowModal = false"><i class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="submitData()"><i class="fa"
            :class="dataSave.idField.data.model ? 'fa-save' : 'fa-save'"></i>
          {{ dataSave.idField.data.model ? 'Lưu lại' : 'Lưu lại' }}
        </button>
      </template>
    </CModal>

    <CModal v-if="dataImport.isShowModal" :title="'Import địa bàn'"
      :show.sync="dataImport.isShowModal" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol sm="12" md="12" xl="12" xs="12" class="form-group">
          <div class="form-input-wrapper">
            <label class="form-label" for="uploadFile">Chọn tệp tin<span class='required'> *</span></label>
            <div class="custom-file"
              :class="dataImport.selectedFiles.data.validator.isValid == false ? 'input-valid-error' : ''">
              <input type="file" class="custom-file-input" id="uploadFile" ref="file"
                :accept="dataImport.selectedFiles.options.acceptFile" @change="selectFile($event)">
              <label class="custom-file-label" for="uploadFile">{{ dataImport.selectedFiles.options.fileName
              }}
                <i v-if="dataImport.selectedFiles.data.loading" class="fa fa-spinner fa-spin"
                  style="position: absolute; right: 100px;font-size: 20px;top: 8px;"></i>
              </label>
            </div>
            <div class="valid-error"
              v-show="!(dataImport.selectedFiles.data.validator ? dataImport.selectedFiles.data.validator.isValid : true)">
              {{ dataImport.selectedFiles.data.validator ?
                dataImport.selectedFiles.data.validator.errorMessage : "" }}
            </div>
          </div>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="dataImport.isShowModal = false"><i
            class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="submitImport()"><i class="fa"
            :class="'fa-upload'"></i> Thực
          hiện
        </button>
      </template>
    </CModal>

    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping"
      ref="actionModal"></ModalConfirm>
  </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import BaseInput from "../base/BaseInput";
import BaseSwitch from "@/views/base/BaseSwitch";
import BaseSelect from "@/views/base/BaseSelect2";
import ModalConfirm from "../base/BaseModalConfirm";

export default {
  name: "ConfigLocationList",
  components: {
    BaseSwitch,
    BaseTable,
    BaseInput,
    BaseSelect,
    ModalConfirm
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    let that = this;

    let actionTypeMapping = new Map();

    actionTypeMapping.set("delete_one", {
      url: "/location/deleteById",
      titlePopup: function () {
        return that.$helper.setupTitleAction(
          "xóa",
          "địa bàn",
          that.actionData.model.name
        );
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          id: that.actionData.model.id,
        };
      },
      successCallback: function () {
        that.showSuccessMsg({message: "Xóa địa bàn " + that.actionData.model.name + " thành công"});
        that.loadDataMainTable();
      }
    });

    return {
      isShowModal: false,
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          id: null,
          name: null
        }
      },
      dataImport: {
        isShowModal: false,
        selectedFiles: {
          options: {
            fileName: 'Chọn tệp Excel',
            acceptFile: ".xlsx, .xls",
          },
          data: {
            loading: false,
            name: "file",
            model: {
              fileName: '',
              content: '',
              size: '',
              type: ''
            },
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                this.isValid = that.validateFile();
                return this.isValid;
              }
            }
          }
        },
      },
      parentCode: "",
      dataSave: {
        idField: {
          data: {
            name: "id",
            model: ""
          }
        },
        codeInput: {
          options: {
            label: "Mã địa bàn <span class='required'>*</span>",
            placeholder: "Mã địa bàn",
          },
          data: {
            name: "code",
            model: "",
            updateCallback: function () {
              that.submitData();
            },
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.dataSave.codeInput.data.model;
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = "Mã địa bàn không được để trống";
                } else if (value.length > 256) {
                  this.isValid = false;
                  this.errorMessage = "Mã địa bàn được quá 256 kí tự";
                } else {
                  this.isValid = true;
                }
                return this.isValid;
              }
            }
          }
        },
        nameInput: {
          options: {
            label: "Tên địa bàn <span class='required'>*</span>",
            placeholder: "Tên địa bàn",
          },
          data: {
            name: "name",
            model: "",
            updateCallback: function () {
              that.submitData();
            },
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.dataSave.nameInput.data.model;
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = "Tên địa bàn không được để trống";
                } else if (value.length > 256) {
                  this.isValid = false;
                  this.errorMessage = "Tên địa bàn được quá 256 kí tự";
                } else {
                  this.isValid = true;
                }
                return this.isValid;
              }
            }
          }
        },
        sourceIdInput: {
          options: {
            label: "Nguồn ID",
            placeholder: "Nguồn ID",
          },
          data: {
            name: "sourceId",
            model: "",
            updateCallback: function () {
              that.submitData();
            },
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                return this.isValid;
              }
            }
          }
        },
        levelInput: {
          options: {
            label: "Cấp địa bàn <span class='required'>*</span> ",
            filter: false,
          },
          data: {
            name: "level",
            items:
              [
                { key: "0", value: "Tỉnh/Thành phố" },
                { key: "1", value: "Quận/Huyện" },
                { key: "2", value: "Phường/Xã" },
                { key: "3", value: "Thôn" },
              ],
            model: "2",
          },
        },
        parentSelect: {
          options: {
            // lazyLoad: true,
            label: "Trực thuộc <span class='required'>*</span>",
            selectAllText: "Chọn địa bàn",
            'keyField': 'key',
            'valueField': 'value',
          },
          data: {
            model: "",
            name: 'parentCode',
            items: [],
            source: {
              url: "/common/findAllLocationByLevel",
              isJsonContentType: false,
              dataSubmit() {
                return {
                  level: that.dataSave.levelInput.data.model - 1,
                }
              },
              response: function (dataResponse) {
                that.dataSave.parentSelect.data.items = dataResponse.data
                setTimeout(() => {
                  that.dataSave.parentSelect.data.model = that.parentCode;
                }, 100);
              }
            },
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.dataSave.parentSelect.data.model;
                if (value === "" && (that.dataSave.levelInput.data.model != 0)) {
                  this.isValid = false;
                  this.errorMessage = "Địa bàn không được để trống";
                } else {
                  this.isValid = true;
                  this.errorMessage = "";
                }
                return this.isValid;
              }
            },
          }
        },
      },
      codeInput: {
        options: {
          placeholder: "Mã địa bàn",
          label: 'Mã địa bàn'
        },
        data: {
          name: "locationCode",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      nameInput: {
        options: {
          placeholder: "Tên địa bàn",
          label: 'Tên địa bàn'
        },
        data: {
          name: "name",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      mainTable: {
        options: {
          fields: [
            { key: "index", label: "STT", sorter: false, filter: false },
            { key: "code", label: "Mã địa bàn" },
            { key: "sourceId", label: "Nguồn ID" },
            { key: "name", label: "Tên địa bàn" },
            { key: "level", label: "Cấp địa bàn" },
            { key: "parentCode", label: "Trực thuộc" },
            { key: "pathLocation", label: "Nhánh" },
            {key: "action", label: "Thao tác", sorter: false, filter: false}
          ],
          slots: [
            "index", "name", "action"
          ],
          pageSize: 20,
          sorter: true,
          columnFilter: false,
          itemsPerPageSelect: { label: ' ', values: [15, 20, 30, 50, 100], external: true },
          tableFilter: { label: 'Bộ lọc:', placeholder: 'Nhập ký tự cần tìm kiếm', external: false, lazy: true },
        },
        dataSource: {
          url: "/location/getPages",
          dataSubmit: function () {
            var params = that.$helper.setupDataSubmit(that.$data);
            return params;
          },
          response: function (dataResponse) {
            return dataResponse.data;
          },
        },
      },
    }
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    clickAdd() {
      this.isShowModal = true;
      this.dataSave.idField.data.model = "";
      this.dataSave.codeInput.data.model = "";
      this.dataSave.levelInput.data.model = "2";
      this.dataSave.nameInput.data.model = "";
      this.dataSave.parentSelect.data.model = "";
      this.parentCode = "";
    },
    loadById(id) {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/location/find-by-id",
        isJsonContentType: false,
        dataSubmit: function () {
          return {id: id}
        },
        successCallback: function (response) {
          that.isShowModal = true;
          that.$helper.setupDataResponse(that.$data.dataSave, response.data.data);
          that.parentCode = response.data.data.parentCode;
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    submitData() {
      let that = this;
      let urlSubmit = "/location/create";
      if (this.dataSave.idField.data.model) {
        urlSubmit = "/location/update";
      }
      this.$helper.loadDataSource({
        loading: that.loading,
        url: urlSubmit,
        dataRef: function () {
          return that.$data.dataSave;
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data.dataSave);
          } else {
            that.showSuccessMsg({message: that.dataSave.idField.data.model ? "Cập nhật địa bàn thành công" : "Thêm mới địa bàn thành công"});
            that.isShowModal = false
            that.loadDataMainTable()
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    setupImport() {
      this.dataImport.isShowModal = true;
    },
    selectFile() {
      let that = this;
      let reader = new FileReader();
      let file = this.$refs.file;
      if (file && file.files[0]) {
        file = file.files[0];
        this.dataImport.selectedFiles.data.loading = true;
        reader.readAsDataURL(file);

        reader.onload = function () {
          that.dataImport.selectedFiles.options.fileName = file.name;
          that.validateFile(file.type, file.size);
          that.dataImport.selectedFiles.data.model.size = file.size;
          that.dataImport.selectedFiles.data.model.fileName = file.name;
          that.dataImport.selectedFiles.data.model.type = file.type;
        }
        reader.onloadend = function () {
          that.dataImport.selectedFiles.data.loading = false;
        }
      } else {
        that.dataImport.selectedFiles.options.fileName = "Chọn tệp";
        that.dataImport.selectedFiles.data.model.size = "";
        that.dataImport.selectedFiles.data.model.fileName = "";
        that.dataImport.selectedFiles.data.model.type = "";
        that.validateFile();
      }
    },
    validateFile(type, size) {
      let isValid = true;
      if ((type && type != undefined) && (size && size != undefined)) {
        isValid = this.validateFileType(type, size);
      } else {
        if (this.dataImport.selectedFiles.data.model.type && this.dataImport.selectedFiles.data.model.size) {
          isValid = this.validateFileType(this.dataImport.selectedFiles.data.model.type, this.dataImport.selectedFiles.data.model.size);
        } else {
          if (this.dataImport.selectedFiles.data.model.fileName === '') {
            this.dataImport.selectedFiles.data.validator.isValid = false;
            this.dataImport.selectedFiles.data.validator.errorMessage = "Nội dung bản tin không để trống";
            isValid = false;
          }
        }
      }
      return isValid;
    },
    validateFileType(type, size) {
      let isValid = true;
      if (type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || type === "application/vnd.ms-excel") {
        this.dataImport.selectedFiles.data.validator.isValid = true;
        this.dataImport.selectedFiles.data.validator.errorMessage = "";
      } else {
        this.dataImport.selectedFiles.data.validator.isValid = false;
        this.dataImport.selectedFiles.data.validator.errorMessage = "Sai định dạng tệp tin";
        isValid = false;
      }
      return isValid;
    },
    submitImport() {
      let that = this;
      let isValid = true;
      isValid &= this.dataImport.selectedFiles.data.validator.valid();
      if (!isValid) {
        return;
      }
      that.loading.value = true;
      let formData = new FormData();
      formData.append("file", that.$refs.file.files[0]);

      that.$helper.loadDataSource({
        url: "/location/import",
        dataSubmit: function () {
          return formData;
        },
        isMultiPartFormData: true,
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
            that.$helper.setupErrorModel(response.data.data, that.$data.dataSave);
          } else {
            that.showSuccessMsg({ message: "Import địa bàn thành công" });
          }
          that.dataImport.isShowModal = false;

          that.loading.value = false;
          that.dataImport.selectedFiles.options.fileName = "Chọn tệp";
          that.dataImport.selectedFiles.data.model.size = "";
          that.dataImport.selectedFiles.data.model.fileName = "";
          that.dataImport.selectedFiles.data.model.type = "";
          that.loadDataMainTable();
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.loading.value = false
        }
      });
    },
    setupSelectOneAction: function (actionTypeKey, id, name) {
      let actionData = this.actionData.model;
      actionData.id = id || null;
      actionData.name = name || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
  },
  created: function () {
  },
  mounted() {
  },
  watch: {
    'dataSave.levelInput.data.model': function (value) {
      if (value != 0) {
        this.$refs.parentSelect.loadData();
        this.dataSave.parentSelect.data.model = "";
      } else {
        this.dataSave.parentSelect.data.items = [];
        this.dataSave.parentSelect.data.model = "";
      }
    },
  },
  computed: {}
};
</script>
<style scoped></style>
